import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetEquityContractRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetEquityContractResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getEquityContract = (request: GetEquityContractRequest, options?: CashRequestOptions) =>
  post<GetEquityContractRequest, GetEquityContractResponse>('/2.0/cash/get-equity-contract', request, {
    ...options,
    rejectOnError: true,
  })
